class SyncedEmployees {
  constructor(employeesData = {}) {
    this.employees = employeesData.employees || 0;
    this.sync = employeesData.sync || 0;
  }
}

export default SyncedEmployees;
